import "./DesktopNavbar.scss";

import React from "react";
import { NavLink } from "react-router-dom";

import { Logo } from "../../../assets/svg/svgIcons";
import ElementNavBar from "../ElementNavbar/ElementNavbar";
import LogoutNavBar from "../LogoutNavBar/LogoutNavBar";
import navItems from "../NavItems";

const DesktopNavbar: React.FC = () => {
  return (
    <nav
      className={`desktopNavbar`}
      role="navigation"
      aria-label="Site Navigation"
    >
      <div className={`navbar-collapse`}>
        <ul className="navbar-nav">
          <li className="navTitleDiv">
            <NavLink to="/">
              <Logo className="navTitle" />
            </NavLink>
          </li>
          {navItems.map((item) => (
            <ElementNavBar
              key={item.href}
              href={item.href}
              text={item.text}
              icon={item.icon}
              className={item.className}
            />
          ))}
          <LogoutNavBar />
        </ul>
      </div>
    </nav>
  );
};

export default React.memo(DesktopNavbar);
